import DgDropdownMultiple from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgDropdownMultiple.install = function (Vue) {
  Vue.component(DgDropdownMultiple.name, DgDropdownMultiple)
}
export default DgDropdownMultiple

export { DgDropdownMultiple }